import { Route } from '@angular/router';
import { StudentsForImpactEditionComponent } from './students-for-impact-edition.component';
import { AuthGuard } from '../../../shared/services';
import { StudentsForImpactDetailsResolver } from '../students-for-impact-details/students-for-impact-details.resolver';

export const StudentsForImpactEditionRoutes: Route[] = [
    {
      path: 'edit/:id',
      component: StudentsForImpactEditionComponent,
      canActivate: [AuthGuard],
      resolve: {
        user: StudentsForImpactDetailsResolver
      }
    }
  ];
